import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SignUpCard } from '../../components'; //Modal ,CommonCard
import { Link } from 'react-router';
import { GglIcon, FbIcon, IconLogoText, LoginNotiOneStyle, LoginNotiTwoStyle, loginrightBg02, LoginNotiThirdStyle, LoginNotiFourStyle } from '../../img'; // logown,  IconLogo, loginUserBg
import SimpleReactValidator from 'simple-react-validator';

import { signup } from '../../ducks/auth';
import SimpleCrypto from 'simple-crypto-js';
const _secretKey = process.env.REACT_APP_SECRET_KEY_FOR_CRYPTO;
const simpleCrypto = new SimpleCrypto(_secretKey);
import ContentLoader from 'react-content-loader';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
let dt = new Date().setDate(new Date().getDate() + 30);
const expireTime = new Date(dt);
// const expireTime = new Date(dt);

class SignUp extends Component {
  constructor() {
    super();
    this.state = {
      e: '',
      un: '',
      fn: '',
      pd: '',
      openClose: false,
      store: '',
      afi: '',
      userResponse: {},
      utm: '',
    };
    this.validator = new SimpleReactValidator();
  }


  componentDidMount = () => {
    localStorage.removeItem('isOpen');
    localStorage.removeItem('isUserStep');
    this.state.utm = this.props.location.search;
    if (this.props.location.query.e) {
      this.state.e = this.props.location.query.e;
      this.state.fn = this.props.location.query.e.replace(/[0-9]/g, '').toLowerCase().split('.').join(' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ').split('@')[0];
    }
    //stor platfrom time in cookie for 30 day
    if (this.props.location.query.dealify) {
      cookies.set('utyp', 'dealify', { expires: expireTime });
    }
    if (this.props.location.query.appsumo) {
      cookies.set('utyp', 'appsumo', { expires: expireTime });
    }

    //without login create widget, store unique id for 2 hours
    if (this.props.location.query.q) {
      let dt = new Date().setHours(new Date().getHours() + 2);
      let expTime = new Date(dt);
      cookies.set('Ifrm_data', this.props.location.query.q, { expires: expTime });
    }

    this.setState(this.state);
    let mainDiv = document.getElementById('main-wrapper');
    mainDiv.className = 'pb-0 mob-log';
  }

  handlerSignup = (e) => {
    if (window.mixpanel) {
      window.mixpanel.track('signup_click', {
        '$email': ''
      });
    }
    e.preventDefault();
    let that = this;

    if (!that.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let pass = simpleCrypto.encrypt(this.state.pd);
      this.state.pd = pass;
      this.state.aff = cookies.get('aff');// localStorage.getItem('aff');
      if (cookies.get('utyp')) {
        this.state.utyp = cookies.get('utyp');
      }

      //for without login create widget
      if (cookies.get('Ifrm_data')) {
        this.state.Ifrm_data = cookies.get('Ifrm_data');
      }

      this.props.signup(this.state);
      this.state.pd = '';
      this.setState(this.state);
    }
  }

  handleStateChange = (state, value) => {
    this.setState({ [state]: value });
  }

  render() {
    return (
      <div className="nf_login-area" >
        <header className="header-app-login header-containet-login">
          <div className="">
            <Link className="logo-text" to={`${process.env.REACT_APP_ROUTE_PREFIX}`}> Widgetshub</Link>
            {/* <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}wdlist?ds=list`}><img className="logo-icon" src={IconLogo} alt="notifly" /></Link>
            <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}wdlist?ds=list`}><img className="logo-icon-text" src={IconLogoText} alt="notifly" /></Link> */}
          </div>
        </header>
        <div className="wdg_container-login100">
          <div className="wdg_login-col-form  nf_login-box" >
            <div className="wdg-login-part">
              <div className="wdg-login-header  mb-30">
                <h1 className="display-1  brand-color">
                  Sign up   <img className="wlcome-text-logo" style={{ display: 'none' }} src={IconLogoText} alt="" />
                </h1>
                <h4 className=" font-normal">
                  See your growth and get consulting support! &nbsp;
                  {/* <span className="highlight-signup" >
                    No credit card required
                  </span> */}
                </h4>
              </div>
              {this.props.loading === false ?
                <div className="nf_login-block">
                  {/* <div className="login-title">
                    <h3 className="display-3 text-left">Sign up</h3>
                    <h5>Already have an account ? <Link className="text-primary" to={`${process.env.REACT_APP_ROUTE_PREFIX}login`}>Login Now</Link> </h5>
                  </div> */}
                  <div className="or-block-login">
                    <div className="or-btn-group">
                      <button className="nf-btn  nf-btn-icon-login nf-btn-google-login " type="button" >
                        <img className="" src={GglIcon} alt="notifly" />  Google
                      </button>
                      <button className="nf-btn  nf-btn-icon-login nf-btn-facebook-login " type="submit">
                        <img className="" src={FbIcon} alt="notifly" />   <span>Facebook</span>
                      </button>
                      {/* <button className="nf-btn  nf-btn-icon-login nf-btn-wix-login " type="submit" >
                      <img className="" src="https://storage.googleapis.com/wiser_goal/integration/wix.png" alt="notifly" />
                      <span>Wix</span>
                    </button> */}
                    </div>
                    <div className="login-or-text">Or, sign up with your email</div>
                  </div>
                  <SignUpCard
                    handleStateChange={this.handleStateChange}
                    handlerSignup={this.handlerSignup}
                    validator={this.validator}
                    state={this.state}
                  />
                  <h5>Already have an account ? <Link className="text-primary" to='login'>Login Now</Link> </h5>
                </div>
                :
                <ContentLoader
                  height={430}
                  width={540}
                  primaryColor={'#eceef4'}
                  secondaryColor={'#fff'}
                  speed={3}>
                  <rect x="2" y="60" rx="0" ry="0" width="526" height="70" />
                  <rect x="2" y="166" rx="0" ry="0" width="526" height="70" />
                  <rect x="9" y="21" rx="0" ry="0" width="84" height="14" />
                  <rect x="345" y="21" rx="0" ry="0" width="181" height="14" />
                  <rect x="186" y="365" rx="0" ry="0" width="175" height="50" />
                  <rect x="3" y="268" rx="0" ry="0" width="519" height="68" />
                </ContentLoader>
              }
            </div>
          </div>
          <div className="wdg_login-col-banner  nf_login-box" >
            <div className="login-side-text">
              <h2 className="signup-noti-text" style={{ marginBottom: '30px' }}>
                {/* Embed reviews on your place from <br/> Google right on your site */}
                Social Wall For Embed Or Display <br />
                Widgetshub allows the integration of different content, especially from most social platforms.
              </h2>
            </div>
            <div className="login-display-noti" style={{ display: 'none' }}>
              <img className="notifiavtion-one" src={LoginNotiOneStyle} alt="" id='signup-1' style={{ display: 'none' }} />
              <img src={LoginNotiTwoStyle} alt="" id='signup-2' style={{ display: 'none' }} />
              <img src={LoginNotiThirdStyle} alt="" id='signup-3' style={{ display: 'none' }} />
              <img src={LoginNotiFourStyle} alt="" id="signup-4" style={{ display: 'none' }} />
            </div>
            <div className="loginusercomputer">
              <img className="signup-right-img" src={loginrightBg02} alt="" />
            </div>

            {/* <a href='https://wisernotify.com/' className="login-logo">
              <img src={logown} alt="" />
            </a> */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  login: state.signUp,
  fbLogin: state.getIn(['auth', 'fbLogin']),
  loading: state.getIn(['loading', 'state']),
});

const mapDispatchToProps = {
  signup
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(SignUp);


// WEBPACK FOOTER //
// ./src/containers/SignUp/SignUp.js